import { ReportName } from "Util/enums";

export type AvailableInContext = "Estimate" | "Order" | "Shipment";

export interface CommunicationCentreSystemReportEntry {
  reportName: string;
  allowedIn: AvailableInContext[];
}

/** Canonical catalog — keep in sync with shipeezi-settings-ms communication-centre-system-reports.constants.ts */
export const COMMUNICATION_CENTRE_SYSTEM_REPORTS: CommunicationCentreSystemReportEntry[] = [
  { reportName: ReportName.SURVEY_REPORT, allowedIn: ["Estimate"] },
  { reportName: ReportName.ORDER_SUMMARY_REPORT, allowedIn: ["Order"] },
  { reportName: ReportName.INVENTORY_CONDITION, allowedIn: ["Order"] },
  { reportName: ReportName.MECHANICAL_ELECTRICAL_CHECKLIST, allowedIn: ["Order"] },
  { reportName: ReportName.OUTTURN_REPORT, allowedIn: ["Order"] },
  { reportName: ReportName.HIGH_RISK_HIGH_VALUE, allowedIn: ["Order"] },
  { reportName: ReportName.PROPERTY_DAMAGE_REPORT, allowedIn: ["Order"] },
  { reportName: ReportName.LOAD_REPORT, allowedIn: ["Order"] },
];

const isAvailableInContext = (value: string): value is AvailableInContext =>
  value === "Estimate" || value === "Order" || value === "Shipment";

export const getSystemReportsForAvailableIn = (
  availableIn: string[]
): CommunicationCentreSystemReportEntry[] => {
  const contexts = availableIn.filter(isAvailableInContext);
  if (!contexts.length) {
    return [];
  }

  const seen = new Set<string>();
  const result: CommunicationCentreSystemReportEntry[] = [];

  for (const context of contexts) {
    for (const entry of COMMUNICATION_CENTRE_SYSTEM_REPORTS) {
      if (entry.allowedIn.includes(context) && !seen.has(entry.reportName)) {
        seen.add(entry.reportName);
        result.push(entry);
      }
    }
  }

  return result;
};

export const getAllowedReportNamesForAvailableIn = (availableIn: string[]): Set<string> => {
  return new Set(getSystemReportsForAvailableIn(availableIn).map((entry) => entry.reportName));
};

export const isReportAllowedForAvailableIn = (
  reportName: string,
  availableIn: string[]
): boolean => getAllowedReportNamesForAvailableIn(availableIn).has(reportName);
